import { alpha, AppBar, Box, Breadcrumbs as MuiBreadcrumbs, Typography, useTheme } from "@mui/material";
import { Link } from "react-router-dom";

interface Breadcrumb {
    title: string;
    to: string;
}

interface BreadcrumbsProps {
    trail: Breadcrumb[];
}

const Breadcrumbs = ({ trail }: BreadcrumbsProps) => {
    const theme = useTheme();
    const lastIndex = trail.length - 1;

    return (
        <Box>
            <AppBar
                position={"fixed"}
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
                    top: { xs: 63, sm: 71 },
                    right: "unset",
                }}
                elevation={0}
            >
                <Box bgcolor={"alternate.main"} padding={`${theme.spacing(2)} !important`}>
                    <MuiBreadcrumbs aria-label="breadcrumb">
                        {trail.map((breadcrumb, index) => (
                            <span key={index}>
                                {index === lastIndex ? (
                                    <Typography color="text.primary">{breadcrumb.title}</Typography>
                                ) : (
                                    <Link to={breadcrumb.to} className="font-bold no-underline text-primary-500">
                                        {breadcrumb.title}
                                    </Link>
                                )}
                            </span>
                        ))}
                    </MuiBreadcrumbs>
                </Box>
            </AppBar>

            <Box height={56} />
        </Box>
    );
};

export default Breadcrumbs;
